/**
 * The knobs for one scenario, rendered from its manifest entry. Values are
 * looked up by key rather than assumed present, since a stored settings blob
 * from before a knob existed simply falls back to that knob's own default.
 */

import type { ReactElement } from 'react';

import type { ScenarioInfo } from '../../hooks/use-chat.ts';
import { KnobField } from './knob-field.tsx';

export function ScenarioCard({
  scenario,
  values,
  onChange,
  disabled = false,
}: {
  scenario: ScenarioInfo;
  values: Record<string, number | boolean | string>;
  onChange: (key: string, value: number | boolean | string) => void;
  disabled?: boolean;
}): ReactElement {
  return (
    <div className="panel settings__scenario-card">
      <div className="settings__scenario-card-heading">
        <h3 className="mono">{scenario.id}</h3>
        <p className="muted small">{scenario.proves}</p>
      </div>
      <div className="settings__knobs">
        {scenario.knobs.map((knob) => (
          <KnobField
            key={knob.key}
            knob={knob}
            value={values[knob.key]}
            onChange={(value) => {
              onChange(knob.key, value);
            }}
            disabled={disabled}
          />
        ))}
      </div>
      {disabled && (
        <p className="muted settings__scenario-card-note small">
          Randomizer mode is drawing these values from their ranges for the next run. Turn it off to
          set them by hand.
        </p>
      )}
    </div>
  );
}
